var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCircles = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5795 6.7405C10.767 6.55305 10.767 6.24913 10.5795 6.06168C10.3921 5.87423 10.0882 5.87423 9.90071 6.06168L7.04012 8.92227L6.09953 7.98168C5.91208 7.79423 5.60816 7.79423 5.42071 7.98168C5.23325 8.16913 5.23325 8.47305 5.42071 8.66051L6.70071 9.94051C6.88816 10.128 7.19208 10.128 7.37953 9.94051L10.5795 6.7405Z",
    fill: "#4FC814"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00012 1.12109C4.2004 1.12109 1.12012 4.20137 1.12012 8.00109C1.12012 11.8008 4.2004 14.8811 8.00012 14.8811C11.7998 14.8811 14.8801 11.8008 14.8801 8.00109C14.8801 4.20137 11.7998 1.12109 8.00012 1.12109ZM2.08012 8.00109C2.08012 4.73157 4.73059 2.08109 8.00012 2.08109C11.2696 2.08109 13.9201 4.73157 13.9201 8.00109C13.9201 11.2706 11.2696 13.9211 8.00012 13.9211C4.73059 13.9211 2.08012 11.2706 2.08012 8.00109Z",
    fill: "#4FC814"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircles, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Circles.c24234ec.svg";
export { ForwardRef as ReactComponent };